import { render, staticRenderFns } from "./Warranty-Detail.vue?vue&type=template&id=51a2cbca&scoped=true"
import script from "./Warranty-Detail.vue?vue&type=script&lang=js"
export * from "./Warranty-Detail.vue?vue&type=script&lang=js"
import style0 from "./Warranty-Detail.vue?vue&type=style&index=0&id=51a2cbca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a2cbca",
  null
  
)

export default component.exports